import { render, staticRenderFns } from "./ItemSubTypesList.vue?vue&type=template&id=40bd7338"
import script from "./ItemSubTypesList.vue?vue&type=script&lang=js"
export * from "./ItemSubTypesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports